import { ITab } from 'shared/components/buttons/tab-button/tab-button-interface';

export enum LocationTab {
  SUB_LOCATIONS = 'sub-locations',
}

export const locationTabs: ITab[] = [
  {
    label: 'Sub Locations',
    key: LocationTab.SUB_LOCATIONS,
  },
];
